module.exports = __webpack_public_path__ + "img/5.fae32c9c.jpg";